import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { LoginService } from 'src/app/services/login.service';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-select-mall',
  templateUrl: './select-mall.component.html',
  styleUrls: ['./select-mall.component.scss']
})
export class SelectMallComponent implements OnInit {
  searchText: any = [];
  filteredListOfMalls: any[] = [];
  selectedMallCode: any = null;
  mallList: any[] = [];
  disableSearch: boolean = false;
  countryCode: any = [];
  selectedCountryCode: any;
  url: string;
  constructor(private router: Router, private loginService: LoginService, private toasterService: ToasterService, public config: ConfigService) { }

  ngOnInit() {
    this.config.getLocalStorageData();
    this.getMalls();
    this.url = this.config.cdnURL + '/CDN/' + this.config._tid;
  }

  getMalls() {
//      this.mallList =  [
//               {
//                   "oko_Row_Code": 879167591707213,
//                   "oko_Row_Desc": "Nexus Seawoods",
//                   "branch_City_Name": "Navi Mumbai" ,
//                   "FYNDDefault" : true
//               },
//             ]
//     this.mallList = [
//       {
//         "oko_Row_Code": 879167591707213,
//         "oko_Row_Desc": "Nexus Seawoods",
//         "branch_City_Name": "Navi Mumbai",
//         "FYNDDefault": true
//       },
//       {
//         "oko_Row_Code": 879167597072134,
//         "oko_Row_Desc": "Nexus Esplande",
//         "branch_City_Name": "Navi Mumbai",
//         "FYNDDefault": true
//       },

//       {
//         "oko_Row_Code": 879167597072137,
//         "oko_Row_Desc": "City",
//         "branch_City_Name": "Navi Mumbai",
//         "FYNDDefault": false
//       },
//   {
//         "oko_Row_Code": 879167597072138,
//         "oko_Row_Desc": "Elante",
//         "branch_City_Name": "Navi Mumbai",
//         "FYNDDefault": true
//       },
//         {
//         "oko_Row_Code": 879167597072139,
//         "oko_Row_Desc": "Celebration",
//         "branch_City_Name": "Navi Mumbai",
//         "FYNDDefault": false
//       },
//  {
//         "oko_Row_Code": 879167597072149,
//         "oko_Row_Desc": "Whitefield",
//         "branch_City_Name": "Navi Mumbai",
//         "FYNDDefault": true
//       },
//       {
//         "oko_Row_Code": 879167597072159,
//         "oko_Row_Desc": "Koramangla",
//         "branch_City_Name": "Navi Mumbai",
//         "FYNDDefault": true
//       },
      
//     ]



    this.loginService.fetchMalls(this.constructor.name).subscribe(result => {
      console.log(this.disableSearch)
      if (result["message"].code == 0) {
        this.mallList = result["data"].Response;

        if (this.mallList.length == 1) {

          this.disableSearch = true;
          console.log(this.disableSearch)
          this.selectedMallCode = this.mallList[0].oko_Row_Code;
        } else {

          this.disableSearch = false;
          console.log(this.disableSearch)
        }
        this.filteredListOfMalls = this.mallList;

      } else if (result["message"].code == 1005) {
        this.toasterService.pop("error", result["message"].message)
      } else {
        this.toasterService.pop("error", result["message"].message)
      }
    })
  }

  onInput(e) {
    console.log(e)
    //let searchedGroup = [];
    if (this.searchText.length) {
      // this.initializeItems(search);
      if (this.searchText && this.searchText.trim() != '') {
        let searchedGroup = this.mallList.filter((item) => {
          return (item.oko_Row_Desc.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
        });
        if (searchedGroup.length > 0) {
          this.filteredListOfMalls = searchedGroup;
        }
        else {
          this.filteredListOfMalls = [];
        }
      }
    } else {
      this.filteredListOfMalls = this.mallList;
    }


    document.getElementById('input').addEventListener('input', (e) => {
      // console.log(e)
      // console.log(e["inputType"])

      if (e["inputType"] != "insertText" && e["inputType"] != "deleteContentBackward") {
        return this.filteredListOfMalls = this.mallList;
      }
    })

  }

  onMallChange(e) {
  console.log("Selected mall:", this.selectedMallCode);
}
  selectMall(item: any) {
    this.selectedMallCode = item.oko_Row_Code;
  }  

  signUp(e) {
    if (this.selectedMallCode != null && this.selectedMallCode != '') {
      localStorage.setItem("userSelectedMallCode", this.selectedMallCode);

      this.loginService.signUpByUser(this.config.countryCode, this.config.mobNumber, this.selectedMallCode).subscribe(result => {
        if (result["message"]["code"] == 0) {
          this.toasterService.pop("success", result["message"]["message"]); ////"User Register Successfully",
          this.url = result["data"].data.url;
          localStorage.clear();
          window.location.href = this.url;
        } else if (result["code"] == 1015) {
          this.toasterService.pop("error", result["message"]["message"]);//"User Already Registered",

        } else if (result["code"] == 701) {
          this.toasterService.pop("error", result["message"]["message"]);  //"Invalid Country Code Used",
        }else if (result["code"] == 8045) {
          this.toasterService.pop("error", result["message"]["message"]);  //": "Mall Name not found",
        }else if (result["code"] == 7002) {
          this.toasterService.pop("error", result["message"]["message"]); //"Invalid Mobile Number Input",
        } else {
          this.toasterService.pop("error", result["message"]["message"]);
        }

      })


    } else {
      this.toasterService.pop("error", "Please select Mall to Proceed!")
    }

  }
 

  // open() {
  //   this.popupVisible = !this.popupVisible
  //   this.filteredCountry = this.countryCode;
  // }

  // closePopup() {
  //   this.popupVisible = false;
  // }




  // searchWthCountryOrCode(e) {
   
  //   if (this.searchCountryOrCode && this.searchCountryOrCode.trim() !== '') {
  //     let searchValue = this.searchCountryOrCode.toLowerCase();

  //     let searchedCountry = this.countryCode.filter((item) => {
  //       let telCode = item.country_TEL_Code != null ? item.country_TEL_Code.toString() : "";
  //       return (
  //         item.country_Name.toLowerCase().includes(searchValue) ||
  //         telCode.includes(searchValue)
  //       );
  //     });
     
  //     this.filteredCountry = searchedCountry.length > 0 ? searchedCountry : [];
  //   } else {
  //     this.filteredCountry = this.countryCode; // reset full list
  //   }
 
  // }

}
